<template>
  <div class="modal"
       id="modal-update-coupon"
       tabindex="-1"
       role="dialog">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">
            Edit Coupon #{{ coupon.id }}
          </h5>
        </div>

        <div class="modal-body">
          <form role="form">
            <div class="form-group row">
              <label for="name" class="col-md-4 col-form-label text-md-right">Name</label>

              <div class="col-md-6">
                <input id="name"
                       type="text"
                       class="form-control"
                       name="name"
                       v-model="updateCouponForm.name"
                       :class="{'is-invalid': updateCouponForm.errors.has('name')}"
                       required autofocus>

                <span class="invalid-feedback"
                      role="alert"
                      v-if="updateCouponForm.errors.has('name')">
                  <strong>{{ updateCouponForm.errors.get('name') }}</strong>
                </span>
              </div>
            </div>

            <div class="form-group row">
              <label for="code" class="col-md-4 col-form-label text-md-right">Code</label>

              <div class="col-md-6">
                <input id="code"
                       type="text"
                       class="form-control"
                       name="code"
                       v-model="updateCouponForm.code"
                       :class="{'is-invalid': updateCouponForm.errors.has('code')}"
                       required autofocus>

                <span class="invalid-feedback"
                      role="alert"
                      v-if="updateCouponForm.errors.has('code')">
                  <strong>{{ updateCouponForm.errors.get('code') }}</strong>
                </span>
              </div>
            </div>

            <div class="form-group row">
              <label for="couponType" class="col-md-4 col-form-label text-md-right">Type</label>

              <div class="col-md-6">
                <div class="form-check">
                  <input v-model="updateCouponForm.coupon_type" class="form-check-input" id="couponTypePercentageUpdate"
                         type="radio" name="coupon_type"
                         value="percentage">
                  <label class="form-check-label" for="couponTypePercentageUpdate">
                    Percentage
                  </label>
                </div>

                <div class="form-check">
                  <input v-model="updateCouponForm.coupon_type"
                         class="form-check-input"
                         id="couponTypeAmountUpdate"
                         type="radio" name="coupon_type"
                         value="amount">
                  <label class="form-check-label" for="couponTypeAmountUpdate">
                    Amount
                  </label>
                </div>
              </div>
            </div>

            <div v-if="updateCouponForm.coupon_type === 'percentage'" class="form-group row">
              <label for="percentage-update" class="col-md-4 col-form-label text-md-right">Percentage off</label>
              <div class="col-md-6">
                <input id="percentage-update" type="number" min="0" max="100"
                       v-model="updateCouponForm.percentage"
                       class="form-control"
                       :class="{'is-invalid': updateCouponForm.errors.has('percentage')}"
                       name="percentage"
                       required>

                <span class="invalid-feedback"
                      role="alert"
                      v-if="updateCouponForm.errors.has('percentage')">
                  <strong>{{ updateCouponForm.errors.get('percentage') }}</strong>
                </span>
              </div>
            </div>

            <div v-if="updateCouponForm.coupon_type === 'amount'" class="form-group row">
              <label for="amount-update" class="col-md-4 col-form-label text-md-right">Discount amount</label>
              <div class="col-md-6">
                <input id="amount-update" type="number" min="0"
                       v-model="updateCouponForm.amount"
                       class="form-control"
                       :class="{'is-invalid': updateCouponForm.errors.has('amount')}"
                       name="amount"
                       required>

                <span class="invalid-feedback"
                      role="alert"
                      v-if="updateCouponForm.errors.has('amount')">
                  <strong>{{ updateCouponForm.errors.get('amount') }}</strong>
                </span>
              </div>

            </div>

            <div class="form-group row">
              <div class="col-md-4 text-md-right">
                <input v-model="limitNumberUsageChecked"
                       id="update_limit_number_usage_status"
                       type="checkbox"
                       class="form-control-sm"
                       :class="{'is-invalid': updateCouponForm.errors.has('limit_count')}">
              </div>
              <label for="update_limit_number_usage_status" class="col-md-6 col-form-label">
                Limit the number of usage
              </label>
            </div>

            <div v-if="limitNumberUsageChecked" class="form-group row">
              <div class="col-md-6 offset-md-4">
                <input v-model="updateCouponForm.limit_count"
                       id="limit_count"
                       type="number"
                       :class="{'is-invalid': updateCouponForm.errors.has('limit_count')}"
                       class="form-control">
                <span class="invalid-feedback"
                      role="alert"
                      v-if="updateCouponForm.errors.has('limit_count')">
                  <strong>{{ updateCouponForm.errors.get('limit_count') }}</strong>
                </span>
              </div>
            </div>

            <div class="form-group row">
              <div class="col-md-4 text-md-right">
                <input v-model="limitDateChecked"
                       id="update_limit_date_status"
                       type="checkbox"
                       class="form-control-sm"
                       :class="{'is-invalid': updateCouponForm.errors.has('limit_count')}">
              </div>
              <label for="update_limit_date_status" class="col-md-6 col-form-label">
                Limit the date when coupon can be used
              </label>
            </div>

            <div v-if="limitDateChecked" class="form-group row">
              <div class="col-md-6 offset-md-4">
                <input v-model="updateCouponForm.ends_at"
                       id="ends_at"
                       type="date"
                       class="form-control">
                <span class="text-sm text-danger font-weight-bold"
                      role="alert"
                      v-if="updateCouponForm.errors.has('ends_at')">
                  <strong>{{ updateCouponForm.errors.get('ends_at') }}</strong>
                </span>
              </div>
            </div>

            <div class="form-group row">
              <div class="col-md-4 text-md-right">
                <input v-model="updateCouponForm.active"
                       id="active"
                       type="checkbox"
                       class="form-control-sm">
              </div>
              <label for="active" class="col-md-6 col-form-label">
                Active
              </label>
            </div>

          </form>
        </div>

        <div class="modal-footer">
          <button type="button"
                  class="btn btn-default"
                  data-dismiss="modal">
            Close
          </button>
          <button type="button"
                  class="btn btn-primary"
                  @click="updateCoupon"
                  :disabled="updateCouponForm.busy">
            Update
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import App from '../../../forms/http';
import moment from 'moment/moment';

export default {
  props: ['coupon'],

  /**
   * The component's data.
   */
  data () {
    return {
      limitDateChecked: false,
      limitNumberUsageChecked: false,
      updateCouponForm: new AppForm({
        name: null,
        code: null,
        coupon_type: null,
        percentage: null,
        amount: null,
        active: null,
        ends_at: null,
      }),
    };
  },

  mounted () {
    this.initData(this.coupon);
  },

  watch: {
    coupon: function (newCoupon, oldCoupon) {
      this.initData(newCoupon);
    }
  },

  methods: {
    initData (coupon) {
      this.updateCouponForm.name = coupon.name;
      this.updateCouponForm.code = coupon.code;
      this.updateCouponForm.coupon_type = coupon.type;
      this.updateCouponForm.percentage = coupon.percentage;
      this.updateCouponForm.amount = coupon.amount;
      this.updateCouponForm.ends_at = coupon.ends_at ? moment(String(coupon.ends_at)).format('YYYY-MM-DD') : null;
      this.updateCouponForm.limit_count = coupon.limit_count;
      this.updateCouponForm.active = coupon.active;
      this.limitDateChecked = !!coupon.ends_at;
      this.limitNumberUsageChecked = !!coupon.limit_count;
    },

    updateCoupon () {
      let self = this;

      if (this.updateCouponForm.coupon_type === 'percentage') {
        delete this.updateCouponForm.amount;
      } else {
        delete this.updateCouponForm.percentage;
      }

      if (!this.limitNumberUsageChecked || !this.updateCouponForm.limit_count) {
        delete this.updateCouponForm.limit_count;
      }

      if (!this.limitDateChecked) {
        delete this.updateCouponForm.ends_at;
      }

      App.put('/api/coupons/' + this.coupon.id, this.updateCouponForm)
        .then(() => {

          $('#modal-update-coupon').modal('hide');
          self.$parent.$emit('updateCoupons');
          self.$parent.$emit('getCoupon', self.coupon.id);
          self.$parent.$emit('updateCoupons');
        });
    },
  }
};
</script>
